<template>
  <transition name="modal-fade">
    <div v-if="visible" class="modal-mask" @click.self="handleClose">
      <div class="modal-panel" :class="{ 'is-detail': !!detail }" role="dialog" aria-modal="true">
        <div class="panel-header">
          <template v-if="detail">
            <button type="button" class="back-btn" @click="detail = null">
              <i class="bi bi-arrow-left"></i> 返回列表
            </button>
            <h2 class="detail-header-title">{{ detail.title }}</h2>
          </template>
          <h2 v-else>我的私信</h2>
          <button type="button" class="close-btn" aria-label="关闭" @click="handleClose">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>

        <div v-if="!detail" class="panel-body list-body">
          <div v-if="loading" class="state-box">加载中...</div>
          <div v-else-if="!messages.length" class="state-box">暂无私信记录</div>
          <div v-else class="message-list">
            <button
                v-for="item in messages"
                :key="item.messageId"
                type="button"
                class="message-item"
                :class="{ unread: item.isRead !== '1' }"
                @click="openDetail(item)">
              <span v-if="item.isRead !== '1'" class="dot"></span>
              <div class="item-main">
                <div class="item-title">{{ item.title }}</div>
                <div class="item-summary">{{ summary(item.content) }}</div>
                <div class="item-time">{{ formatTime(item.createTime) }}</div>
              </div>
              <i class="bi bi-chevron-right item-arrow"></i>
            </button>
          </div>
        </div>

        <div v-else class="panel-body detail-body">
          <div class="detail-meta">{{ formatTime(detail.createTime) }}</div>
          <div class="detail-content">{{ detail.content }}</div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { listMessages, readMessage } from '@/api/portal/message'
import { emitMessageUnreadChanged } from '@/utils/userMenu'

export default {
  name: 'MemberMessageHistoryModal',
  props: {
    visible: { type: Boolean, default: false }
  },
  data() {
    return {
      loading: false,
      messages: [],
      detail: null
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.detail = null
        this.loadMessages()
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
    loadMessages() {
      this.loading = true
      listMessages()
        .then(res => {
          this.messages = res.data || []
        })
        .catch(() => {
          this.messages = []
        })
        .finally(() => {
          this.loading = false
        })
    },
    summary(content) {
      const text = (content || '').replace(/\s+/g, ' ').trim()
      if (!text) {
        return '点击查看详情'
      }
      return text.length > 60 ? text.slice(0, 60) + '...' : text
    },
    openDetail(item) {
      this.detail = item
      if (item.isRead !== '1') {
        readMessage(item.messageId)
          .then(() => {
            item.isRead = '1'
            emitMessageUnreadChanged()
          })
          .catch(() => {})
      }
    },
    formatTime(val) {
      if (!val) {
        return ''
      }
      return String(val).replace('T', ' ').slice(0, 16)
    }
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  inset: 0;
  z-index: 2300;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(15, 23, 42, 0.5);
  backdrop-filter: blur(4px);
}

.modal-panel {
  width: min(520px, 100%);
  max-height: min(80vh, 640px);
  border-radius: 20px;
  background: #fff;
  box-shadow: 0 24px 48px rgba(79, 70, 229, 0.18);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.modal-panel.is-detail {
  max-height: min(75vh, 560px);
}

.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 20px;
  border-bottom: 1px solid #eef0f8;
  flex-shrink: 0;
}

.panel-header h2 {
  margin: 0;
  font-size: 18px;
  color: #1f2937;
}

.detail-header-title {
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 16px;
  font-weight: 600;
}

.back-btn {
  border: none;
  background: transparent;
  color: #1976d2;
  cursor: pointer;
  font-size: 13px;
  white-space: nowrap;
}

.close-btn {
  border: none;
  background: transparent;
  color: #94a3b8;
  cursor: pointer;
  font-size: 18px;
  flex-shrink: 0;
}

.panel-body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

.list-body {
  padding: 8px;
}

.state-box {
  padding: 48px 20px;
  text-align: center;
  color: #94a3b8;
  font-size: 14px;
}

.message-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.message-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 12px 14px;
  border: none;
  border-radius: 12px;
  background: #fff;
  text-align: left;
  cursor: pointer;
}

.message-item:hover {
  background: #f8f9ff;
}

.message-item.unread {
  background: #f7f7fd;
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #1976d2;
  flex-shrink: 0;
}

.item-main {
  flex: 1;
  min-width: 0;
}

.item-title {
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 4px;
}

.item-summary {
  font-size: 13px;
  color: #64748b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.item-time {
  margin-top: 6px;
  font-size: 12px;
  color: #94a3b8;
}

.item-arrow {
  color: #cbd5e1;
  flex-shrink: 0;
}

.detail-body {
  padding: 16px 20px 24px;
}

.detail-meta {
  margin-bottom: 12px;
  font-size: 12px;
  color: #94a3b8;
}

.detail-content {
  white-space: pre-wrap;
  word-break: break-word;
  line-height: 1.7;
  color: #334155;
  font-size: 14px;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.2s ease;
}

.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}
</style>
